module.exports = __webpack_public_path__ + "static/media/bg22.c07ab482.jpg";